import { Navigate, Outlet, useLocation } from 'react-router';
import { ErrorState } from '@/design-system/components/states';
import { NoOrganizationPage, Splash } from '@/features/system/system-pages';
import { ApiError } from '@/lib/api';
import { useSession } from '@/lib/session';

/** Guarda das rotas internas. A autorização real é do servidor; aqui só decidimos a tela. */
export function RequireSession() {
  const session = useSession();
  const location = useLocation();

  if (session.isPending) return <Splash />;
  if (session.isError) {
    const err = session.error;
    if (err instanceof ApiError && err.status === 401) {
      const next = location.pathname + location.search;
      return <Navigate to={next === '/' ? '/login' : `/login?next=${encodeURIComponent(next)}`} replace />;
    }
    if (err instanceof ApiError && err.code === 'NO_ORGANIZATION') return <NoOrganizationPage />;
    return (
      <div className="flex min-h-dvh items-center justify-center bg-canvas">
        <ErrorState error={err} onRetry={() => session.refetch()} />
      </div>
    );
  }
  // Usuários do cliente usam o portal próprio (SPEC §25), nunca o app interno; e vice-versa.
  const isClient = session.data.role === 'client_admin' || session.data.role === 'client_member';
  const inPortal = location.pathname === '/portal' || location.pathname.startsWith('/portal/');
  if (isClient && !inPortal) return <Navigate to="/portal" replace />;
  if (!isClient && inPortal) return <Navigate to="/" replace />;
  return <Outlet />;
}
